// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}

.container {
  position: relative;
  min-width: 90vw;
  margin-left: 0;
  margin-right: 0;
  top: 7rem;
  left: 5rem;
}
.container > .box > .swiperpicshome > .is-flex-direction-row > ul {
  margin-left: 0;
}
.container > .box > .swiperpicshome > .is-flex-direction-row > ul > li {
  list-style-type: none;
}
.container > .mainBox {
  width: 75%;
  height: 80vh !important;
  overflow: scroll;
}
.container > .asideMenu {
  width: 20%;
  height: 80vh !important;
  overflow: scroll;
  padding: 1rem;
  border: 1px solid #c8cbd1;
  border-radius: 0.5rem;
}
.foot {
  display: none;
}
.heroTitle {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #c8cbd1;
}
.notification {
  position: absolute !important;
  display: inline-block;
  /* right: 0;
  top: -4.5vh; */
  top: -8.5vh;
  left: 35%;
  min-width: 30%;
  animation: move 2s;
  animation-direction: normal;
  animation-iteration-count: 1;
  z-index: 9999 !important;
  font-size: 0.75rem;
}
@keyframes move {
  0% {
    transform: translateY(-103%);
  }
  100% {
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB;gBACc;EACd,WAAW;EACX,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["html {\n  scroll-behavior: smooth;\n}\n\n.container {\n  position: relative;\n  min-width: 90vw;\n  margin-left: 0;\n  margin-right: 0;\n  top: 7rem;\n  left: 5rem;\n}\n.container > .box > .swiperpicshome > .is-flex-direction-row > ul {\n  margin-left: 0;\n}\n.container > .box > .swiperpicshome > .is-flex-direction-row > ul > li {\n  list-style-type: none;\n}\n.container > .mainBox {\n  width: 75%;\n  height: 80vh !important;\n  overflow: scroll;\n}\n.container > .asideMenu {\n  width: 20%;\n  height: 80vh !important;\n  overflow: scroll;\n  padding: 1rem;\n  border: 1px solid #c8cbd1;\n  border-radius: 0.5rem;\n}\n.foot {\n  display: none;\n}\n.heroTitle {\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #c8cbd1;\n}\n.notification {\n  position: absolute !important;\n  display: inline-block;\n  /* right: 0;\n  top: -4.5vh; */\n  top: -8.5vh;\n  left: 35%;\n  min-width: 30%;\n  animation: move 2s;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  z-index: 9999 !important;\n  font-size: 0.75rem;\n}\n@keyframes move {\n  0% {\n    transform: translateY(-103%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
